import './SampleContainer.component.css'

import { Circle, Layer } from 'react-konva'

import PropTypes from 'prop-types'
import React from 'react'
import { SampleComponent } from '../Sample/Sample.component'
import { axios } from 'config/axios'
import { getUpdateSampleChangerLocationURL } from '../../../api/ispyb'

export class SampleContainerComponent extends React.Component {
  constructor(props) {
    super(props)
    this.props = props
    this.state = {
      samples: null,
    }
  }

  getKonvaCircle(
    radius,
    sample_container_position_from_top,
    sample_container_position_from_left,
    sample_container_background_color,
    sample_container_border_color,
    sample_container_border_size,
    onClickFunction
  ) {
    return (
      <Circle
        radius={radius}
        y={sample_container_position_from_top}
        x={sample_container_position_from_left}
        fill={sample_container_background_color}
        stroke={sample_container_border_color}
        strokeEnabled
        strokeWidth={sample_container_border_size}
        onClick={onClickFunction}
      />
    )
  }

  renderSample(sample, sample_position_from_top, sample_position_from_left, onClickFunction) {
    return (
      <SampleComponent
        onMouseOverSample={(a, b, c, d) => {
          this.props.onMouseOverSample(a, b, c, d)
        }}
        samplechanger_position_in_container={this.props.position_in_container}
        onClickFunction={onClickFunction}
        sample={sample}
        type={this.props.type}
        configuration={this.props.configuration}
        sample_position_from_top={sample_position_from_top}
        sample_position_from_left={sample_position_from_left}
      />
    )
  }

  getCirclesPositions(distance_from_center, radius, origin, angles) {
    const first_point = { x: origin.x, y: origin.y - Math.abs(distance_from_center) }
    const res = []
    angles.forEach(angle => {
      const point = this.rotate(first_point, origin, angle)
      point.x = Math.abs(point.x)
      point.y = Math.abs(point.y)
      res.push(point)
    })
    return res
  }

  renderSpinepuck(onClickFunction) {
    const sampleElements = []
    const exteriorAngles = this.getAnglesList(0, 10)

    const origin = {
      y: this.props.sample_container_position_from_top,
      x: this.props.sample_container_position_from_left,
    }

    const positions = this.getCirclesPositions(
      this.props.sample_container_radius * 0.75,
      this.props.sample_container_radius,
      origin,
      exteriorAngles
    )

    positions.forEach((element, index) => {
      const current_sample = this.props.samples.find(x => x.position === index + 1)

      if (current_sample) {
        sampleElements.push(this.renderSample(current_sample, element.y, element.x, onClickFunction))
      } else {
        sampleElements.push(
          this.renderSample(
            {
              sampleName: '',
              proteinAcronyme: '',
              position: index + 1,
              status: 'EMPTY',
            },
            element.y,
            element.x,
            onClickFunction
          )
        )
      }
    })

    return sampleElements
  }

  renderUnipuck(onClickFunction) {
    const sampleElements = []
    const exteriorAngles = this.getAnglesList(0, 11)
    const interiorAngles = this.getAnglesList(0, 5)

    const origin = {
      y: this.props.sample_container_position_from_top,
      x: this.props.sample_container_position_from_left,
    }

    let positions = []

    positions = positions.concat(
      this.getCirclesPositions(
        this.props.sample_container_radius * 0.35,
        this.props.sample_container_radius,
        origin,
        interiorAngles
      )
    )

    positions = positions.concat(
      this.getCirclesPositions(
        this.props.sample_container_radius * 0.75,
        this.props.sample_container_radius,
        origin,
        exteriorAngles
      )
    )

    positions.forEach((element, index) => {
      const current_sample = this.props.samples.find(x => x.position === index + 1)

      if (current_sample) {
        sampleElements.push(this.renderSample(current_sample, element.y, element.x, onClickFunction))
      } else {
        sampleElements.push(
          this.renderSample(
            {
              sampleName: '',
              proteinAcronyme: '',
              position: index + 1,
              status: 'EMPTY',
            },
            element.y,
            element.x,
            onClickFunction
          )
        )
      }
    })

    return sampleElements
  }

  getAnglesList(initial_angle, number_of_angles) {
    const angles = []

    const angle_step = 360 / number_of_angles

    for (let i = initial_angle; i < 360; i = i + angle_step) {
      angles.push(i)
    }
    return angles
  }

  createSampleComponents(onClickFunction, type) {
    switch (type.toString().trim().toLowerCase()) {
      case 'unipuck':
        return this.renderUnipuck(onClickFunction)
      case 'spinepuck':
        return this.renderSpinepuck(onClickFunction)
    }
  }

  rotate(point, origin, angle) {
    let xM, yM, x, y
    angle *= Math.PI / 180
    xM = point.x - origin.x
    yM = point.y - origin.y
    x = xM * Math.cos(angle) + yM * Math.sin(angle) + origin.x
    y = -xM * Math.sin(angle) + yM * Math.cos(angle) + origin.y
    return { x: Math.round(x), y: Math.round(y) }
  }

  shouldComponentUpdate() {
    return true
  }

  updatePositon() {
    if (this.props.selectedShipment) {
      axios({
        url: getUpdateSampleChangerLocationURL(
          this.props.user,
          this.props.proposalName,
          this.props.selectedShipment.containerId,
          this.props.selectedShipment.beamlineLocation
        ),
        method: 'POST',
        mode: 'no-cors',
        data: 'sampleChangerLocation=' + this.props.position_in_container,
      }).then(() => {
        this.props.fetchDataCallback()
      })
    }
  }

  getNumberOfSampleByContainerType(configuration, type) {
    return configuration.sample_type_mapping[type]
  }

  componentWillUnmount() {
    this.layer.destroyChildren()
    this.layer.destroy()
  }

  render() {
    let borderColor = ''
    let borderSize = 0

    if (
      this.props.theOneContainer &&
      this.props.selectedShipment.containerId === this.props.theOneContainer.containerId
    ) {
      borderColor = this.props.configuration.sample_container_state_legend.SELECTED.drawing
        .sample_container_border_color
      borderSize = this.props.configuration.sample_container_state_legend.SELECTED.drawing.sample_container_border_size
    } else {
      borderColor = this.props.configuration.sample_container_state_legend[this.props.status].drawing
        .sample_container_border_color
      borderSize = this.props.configuration.sample_container_state_legend[this.props.status].drawing
        .sample_container_border_size
    }

    const onclick = () => {
      if (this.props.selectedShipment) {
        this.updatePositon()
        this.props.updateSelectedSampleContainerCallback(this.props.position_in_container)
        this.props.updateSamplesOfSelectedSampleContainerCallback(this.props.samples)
      }
    }

    return (
      <Layer ref={ref => (this.layer = ref)}>
        {this.getKonvaCircle(
          this.props.sample_container_radius,
          this.props.sample_container_position_from_top,
          this.props.sample_container_position_from_left,
          this.props.configuration.sample_container_state_legend[this.props.status].drawing
            .sample_container_background_color,
          borderColor,
          borderSize,
          onclick
        )}
        {this.props.showSamples &&
          this.props.samples &&
          this.createSampleComponents(onclick, this.props.configuration.container_type)}
      </Layer>
    )
  }
}

export default SampleContainerComponent

SampleContainerComponent.propTypes = {
  samples: PropTypes.object,
  configuration: PropTypes.object,
  status: PropTypes.string,
  sample_container_radius: PropTypes.number,
  sample_container_position_from_top: PropTypes.number,
  sample_container_position_from_left: PropTypes.number,
  sample_container_border_size: PropTypes.number,
}
